import ACTION from '../actionTypes';

const initialState = {
  data: [],
  form: {},
  loading: false,
  error: null,
  totalElements: 0,
};

export default function tipoVeiculo(state = initialState, action) {
  switch (action.type) {
    case ACTION.VINCULADA_GET_SEARCH_PAGE:
    case ACTION.VINCULADA_GET_ALL_REQUEST:
    case ACTION.VINCULADA_POST_REQUEST:
    case ACTION.VINCULADA_GET_ID_REQUEST:
    case ACTION.VINCULADA_UPDATE_REQUEST:
    case ACTION.VINCULADA_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ACTION.VINCULADA_GET_ALL_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case ACTION.VINCULADA_GET_SEARCH_PAGE_SUCCESS: {
      const { content, totalElements } = action.data;
      return {
        ...state,
        loading: false,
        error: null,
        data: (content || []).map(row => ({ ...row, key: row.id })),
        totalElements,
      };
    }
    case ACTION.VINCULADA_POST_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ACTION.VINCULADA_UPDATE_SUCCESS:
    case ACTION.VINCULADA_GET_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        form: action.data,
      };
    case ACTION.VINCULADA_DELETE_SUCCESS:
      return {
        ...state,
      };
    case ACTION.VINCULADA_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
